var simpleVideoPlayer = function simpleVideoPlayer() {
  var movieSimpleTrigger = document.querySelectorAll('.x-simple-movie');
  movieSimpleTrigger.forEach(function(element){
    element.addEventListener('click', function (e) {
      var movieUrl = element.dataset.url;
      var videoContainer = element.nextElementSibling;
      var simpleIframeWrapper = videoContainer.querySelector('.x-simple-movie-iframe');
      var iframeUrl = 'https://www.youtube.com/embed/' + movieUrl + '?rel=0&amp;showinfo=0;autoplay=1';
      element.classList.add('hide');
      simpleIframeWrapper.src = iframeUrl;
      videoContainer.classList.remove('hide');
      e.preventDefault();
    });
  });
};
simpleVideoPlayer();
